import {Directive} from '@angular/core';
import {TableBodyRowDirective} from './table-body-row.directive';

@Directive({
    selector: '[tableBodyEmptyRow]',
    standalone: false
})
export class TableBodyEmptyRowDirective<T = any> extends TableBodyRowDirective<T> {}
